/**
 * Helper class that has static functions
 * that ensure invariants in the current content item
 *
 * This should be refactored soon when each content
 * gets his own content description
 * then we dont have this problem
 *
 * athm we need to use this invariants in
 * - Templates
 * - Content Entitites
 * - Update Content
 * - Typeswitch
 */
export class ContentInvariants {
  public static ensurePieInvariants(content) {
    if (content.type === 'piechart') {
      content.typeSpecific.chart.donut.padAngle = 0.01;
      content.typeSpecific.chart.donut.innerRadius = 0.01;
    }
  }
  public static ensureParliamentInvariants(content) {
    if (content.type === 'parliamentchart') {
      content.typeSpecific.chart.donut.degrees = 180;
      content.typeSpecific.chart.donut.autoStartAngle = true;
    }
  }
  public static ensureExtrudeMapInvariants(content) {
    if (content.type === 'extrudemap') {
      content.typeSpecific.map.options.displayType = 'extrude';
    }
  }
  public static ensureBubbleMapInvariants(content) {
    if (content.type === 'bubblemap') {
      content.typeSpecific.map.options.displayType = 'bubbles';
    }
  }
  public static ensureChoroplethMapInvariants(content) {
    if (content.type === 'choropleth') {
      content.typeSpecific.map.options.displayType = 'choropleth';
    }
  }
}
